<template>
    <div class="chat-wrapper">
      <!-- En-tête -->
      <div class="chat-header">
        <v-avatar size="40" class="mr-3">
            <img src="@/assets/images/avatars/grouper.png" alt="avatar" />
          </v-avatar>
        <span class="font-weight-medium text-subtitle-1">
          {{ groupName }}
        </span>
      </div>
  
      <!-- Corps du chat défilable -->
      <div class="chat-body" ref="chatBody">
        <div v-for="(msg, index) in messages" :key="index" class="mb-2">
          <div
            :class="[
              'message-bubble',
              msg.sender === managerUsername ? 'sent' : 'received'
            ]"
          >
            <div class="message-sender">{{ msg.sender }}</div>
            <span class="message-text">{{ msg.content }}</span>
            <div class="message-time">{{ msg.timestamp }}</div>
          </div>
        </div>
      </div>
  
      <!-- Badge de scroll -->
      <v-btn
        v-if="unreadCount > 0"
        color="primary"
        class="scroll-badge"
        @click="scrollToBottom(true)"
      >
        {{ unreadCount }}
      </v-btn>
  
      <!-- Pied de page -->
      <div class="chat-footer">
        <v-row no-gutters align="center" class="pa-2">
          <v-btn icon class="mr-2" @click="showEmojiPicker = !showEmojiPicker">
            <i class="fa-solid fa-face-smile"></i>
          </v-btn>
  
          <div
            ref="emojiPicker"
            class="emoji-picker-container"
            v-if="showEmojiPicker"
          >
            <Picker
              :data="data"
              set="apple"
              title="Pick your emoji"
              emoji="point_up"
              @select="addEmoji"
            />
          </div>
  
          <v-textarea
            v-model="newMessage"
            placeholder="Tapez un message"
            rows="1"
            auto-grow
            solo
            hide-details
            class="flex-grow-1"
            @keydown.enter.exact.prevent="sendMessage"
          >
            <template #input>
              <textarea ref="inputField" />
            </template>
          </v-textarea>
  
          <v-btn
            icon
            color="primary"
            v-if="newMessage.trim() !== ''"
            @click="sendMessage"
          >
            <i class="fa-solid fa-paper-plane"></i>
          </v-btn>
        </v-row>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { Picker } from 'emoji-mart-vue'
  import 'emoji-mart-vue/css/emoji-mart.css'
  
  export default {
    components: { Picker },
    data() {
      return {
        listIds: [],
        groupName: '',
        messages: [],
        newMessage: '',
        managerUsername: '',
        showEmojiPicker: false,
        unreadCount: 0,
        autoScrollEnabled: true,
      }
    },
    mounted() {
      this.listIds = this.$route.params.list_ids.split('-')
      this.groupName = this.$route.params.group_name
  
      this.fetchMessages()
      this.pollingInterval = setInterval(this.fetchMessages, 3000)
  
      document.addEventListener('click', this.handleOutsideClick)
      this.$refs.chatBody.addEventListener('scroll', this.checkScrollPosition)
    },
    beforeDestroy() {
      clearInterval(this.pollingInterval)
      document.removeEventListener('click', this.handleOutsideClick)
      this.$refs.chatBody.removeEventListener('scroll', this.checkScrollPosition)
    },
    methods: {
      async fetchMessages() {
        try {
          const response = await axios.post(
            '/api/v1/manager/get_chat_group_history/',
            {
              group_name: this.groupName,
              list_id_client: this.listIds,
            }
          )
  
          const newMessages = response.data.list_message
          const wasNewMessage = newMessages.length > this.messages.length
  
          this.messages = newMessages
          this.managerUsername = response.data.priority
  
          if (wasNewMessage && !this.autoScrollEnabled) {
            this.unreadCount++
          }
  
          this.$nextTick(() => {
            if (this.autoScrollEnabled) this.scrollToBottom()
          })
        } catch (error) {
          console.error('Erreur chargement chat:', error)
        }
      },
  
      async sendMessage() {
            if (this.newMessage.trim() === '') return;

            const content = this.newMessage;
            this.newMessage = '';

            try {
                const response = await axios.post('/api/v1/manager/save_chat_group/', {
                message: content,
                list_id_client: this.listIds,
                group_name: this.groupName,
                });

                this.messages.push({
                sender: this.managerUsername,
                content,
                timestamp: new Date().toISOString().slice(0, 19).replace('T', ' '),
                type: 'text',
                });

                this.$nextTick(() => this.scrollToBottom());
            } catch (error) {
                console.error('Erreur envoi message:', error);
            }
            },

  
      scrollToBottom(force = false) {
        const el = this.$refs.chatBody
        if (el) {
          el.scrollTop = el.scrollHeight
          if (force) {
            this.unreadCount = 0
            this.autoScrollEnabled = true
          }
        }
      },
  
      addEmoji(emoji) {
        this.newMessage += emoji.native
        this.$nextTick(() => {
          this.$refs.inputField?.focus()
        })
      },
  
      handleOutsideClick(event) {
        const emojiPicker = this.$refs.emojiPicker
        const inputField = this.$refs.inputField
  
        if (
          emojiPicker &&
          !emojiPicker.contains(event.target) &&
          inputField &&
          !inputField.contains(event.target)
        ) {
          this.showEmojiPicker = false
        }
      },
  
      checkScrollPosition() {
        const el = this.$refs.chatBody
        const threshold = 80
        this.autoScrollEnabled =
          el.scrollTop + el.clientHeight >= el.scrollHeight - threshold
      },
    },
  }
  </script>
  
  <style scoped>
  .chat-wrapper {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 140px);
    border: 1px solid #eee;
    background: #f4f4f4;
  }
  .chat-header {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    background-color: white;
    border-bottom: 1px solid #ddd;
  }
  .chat-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
  }
  .chat-footer {
    background-color: white;
    padding: 8px 16px;
    border-top: 1px solid #ddd;
    position: relative;
  }
  .message-bubble {
    max-width: 60%;
    padding: 10px 14px;
    border-radius: 16px;
    word-wrap: break-word;
    position: relative;
  }
  .sent {
    margin-left: auto;
    background-color: #dcf8c6;
    border-top-right-radius: 0;
  }
  .received {
    margin-right: auto;
    background-color: #fff;
    border-top-left-radius: 0;
  }
  .message-time {
    font-size: 0.75rem;
    color: #999;
    margin-top: 4px;
    text-align: right;
  }
  .message-sender {
    font-weight: bold;
    font-size: 0.9rem;
    margin-bottom: 4px;
  }
  .emoji-picker-container {
    position: absolute;
    bottom: 60px;
    left: 0;
    z-index: 10;
  }
  .scroll-badge {
    position: absolute;
    right: 20px;
    bottom: 90px;
    z-index: 15;
    border-radius: 50%;
    min-width: 36px;
    height: 36px;
    font-weight: bold;
    text-align: center;
  }
  </style>
  